<template>
  <div class="m-nav" :class="{ 'bg-white': isFixed }">
    <div class="main">
      <img src="@/assets/img/logo-new.png" alt="" class="logo" />
      <!-- <router-link class="nav-link" to="/mfaq">FAQ</router-link> -->
      <!-- <a class="nav-link" href="https://agent-credit-h5.brmfbank.com/">MerchantLoan</a> -->

      <router-link class="nav-link" to="/mhome">Home</router-link>
      <router-link class="nav-link" to="/mnotice">Notice</router-link>
    </div>
  </div>
</template>
<script>
import getQueryString from "@/utils/getQuery.js";
export default {
  data() {
    return {
      env: "",
    };
  },
  mounted() {
    this.env = getQueryString("env");
  },
  props: ["isFixed"],
};
</script>
<style lang="scss" scoped>
@import "@/styles/public";

.m-nav {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  padding: 36px 60px;
  line-height: 76px;
  background-color: #fff;
  &.bg-white {
    background-color: #fff;
    box-shadow: 0px 1px 27px 5px rgba(0, 0, 0, 0.06);
  }
  .logo {
    width: 220px;
    vertical-align: middle;
    margin-right: 8px;
    margin-top: 18px;
  }
  .logo-name {
    display: inline-block;
    font-size: 40px;
    margin-right: 0px;
    font-weight: bold;
  }
  .nav-link {
    float: right;
    font-size: 48px;
    margin-left: 76px;
    padding-bottom: 4px;
    height: 86px;
    line-height: 86px;
    color: #132647;
    &.router-link-exact-active {
      font-weight: bold;
      color: $theme-color;
    }
  }
}
</style>
